import { CANDIDATE_TABS, CANDIDATE_TAB_RENDER_FLAGS } from '@/pages/Candidate/hooks/useCandidateTabs/constants';
import { CandidateTab, UseCandidateTabs } from '@/pages/Candidate/hooks/useCandidateTabs/types';
import { isEnabled, isTabForceVisible } from '@/pages/Candidate/hooks/useCandidateTabs/utils';
import { FCRAWorker } from '@/types/turn-api';

/** Tabs with add/request actions stay visible even when empty. */
const ACTION_TABS: ReadonlySet<CandidateTab> = new Set(['addresses', 'checks', 'notes', 'one_off_checks']);

const isTabAvailableForRecord = (record: FCRAWorker.Details | null | undefined, tab: CandidateTab): boolean => {
  if (isTabForceVisible(tab, CANDIDATE_TABS)) return true;
  if (tab === 'summary') return true;
  if (ACTION_TABS.has(tab)) return true;
  const availability = record?.tab_availability;
  if (!availability) return true;
  return availability[tab] === true;
};

const useCandidateTabs = (record?: FCRAWorker.Details | null): UseCandidateTabs => {
  const tabRenderFlagsMap = (Object.entries(CANDIDATE_TAB_RENDER_FLAGS) as [CandidateTab, string | undefined][]).reduce(
    (acc, [tab, flag]) => {
      acc[tab] = isEnabled(flag) && isTabAvailableForRecord(record, tab);
      return acc;
    },
    {} as Record<CandidateTab, boolean>
  );

  return {
    shouldRenderTab: tabRenderFlagsMap,
  };
};

export default useCandidateTabs;
